export const ExcalidrawPlusAppLink = () => {
  // Always return null to hide Excalidraw+ button
  return null;
};
